// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","screen-min":"639px","screen-xs-max":"1023px","screen-sm-max":"1365px"};